import { View } from "binder"
import { NotAuthenticatedUserMainWindowViewModel } from "./notAuthenticatedUserMainWindow-viewModel"
import { WindowContainerViewModel } from "../windowContainer/windowContainer-viewModel";

export class NotAuthenticatedUserMainWindowView extends View<NotAuthenticatedUserMainWindowViewModel>{
    GetViewUniqueId(): string {
        return "V-AFB6F553-8A88-4F27-A1F4-8F1EF7B7258A"
    }
    loadHtml(): string {
        let element = require('./notAuthenticatedUserMainWindow.html').default;
        let style = require('./notAuthenticatedUserMainWindow.less');
        return element;
    }
    constructor() {
       super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set currentForm(v: WindowContainerViewModel) { this._currentForm = v; } public get currentForm(): WindowContainerViewModel { return this._currentForm;} private _currentForm: WindowContainerViewModel;

}
